module.exports = __webpack_public_path__ + "static/media/silver-crown.3b88d795.svg";